import { Container } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks"
import Header from "components/header/Header";
import HolzfinderList from "components/list/HolzfinderList";
import { getCustomerPurchases, selectCustomerPurchasesList, selectCustomerPurchasesTotal } from "features/customer/customerSlice";
import { selectPageCustomerInvoiceList, selectRowsPerPageCustomerInvoiceList, setPageCustomerInvoiceList, setRowsPerPageCustomerInvoiceList } from "features/table/tableSlice";
import formatDate from "hooks/useDate";
import { useState, useEffect, useMemo } from "react";


interface rowInterface {
  id: string;
  created_at: string;
  price_total: string;
}

const tableHeaderList: string[] = ["Gekauft am", "Preis", "Detailansicht"]
export default function CustomerPurchasesList() {
  const [rowData, setRowData] = useState<rowInterface[]>([]);
  const purchasesList = useAppSelector(selectCustomerPurchasesList);
  const purchasesListTotal = useAppSelector(selectCustomerPurchasesTotal) as number;
  const page = useAppSelector(selectPageCustomerInvoiceList)
  const rowsPerPage = useAppSelector(selectRowsPerPageCustomerInvoiceList)
  const dispatch = useAppDispatch();


  const Euro = useMemo(() => new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'EUR',
  }), []);

  useEffect(() => {
    dispatch(setPageCustomerInvoiceList(0));
  }, [dispatch]);


  useEffect(() => {
    dispatch(
      getCustomerPurchases({
        items_per_page: rowsPerPage,
        page: page + 1,
      })
    );
  }, [page, rowsPerPage, dispatch]);

  useEffect(() => {
    if (purchasesList) {
      const mappedData = purchasesList.map(
        (purchase) => ({
          id: purchase.id,
          created_at: formatDate(purchase.created_at),
          price_total: Euro.format(parseInt(purchase.price_total))

        })

      );
      setRowData(mappedData);
    }
  }, [purchasesList, Euro]);

  return (
    <Container sx={{ pl: { lg: 12, md: 12, xs: 1 }, pt: 5, width: "fit-content", minWidth: { xs: "100%", md: 500, lg: 600 } }} maxWidth="md">
      <Header header="Meine Käufe" />
      {/* // TODO: readd search on a later occasion */}
      {/* <Select className={styles.inputs} sx={{ my: 2 }}></Select> */}
      <HolzfinderList
        listLengthTotal={purchasesListTotal}
        rowData={rowData}
        switchActive={false}
        link={`/kunde/meine_einkaeufe/`}
        tableHeaderList={tableHeaderList}
        setPage={setPageCustomerInvoiceList}
        setRowsPerPage={setRowsPerPageCustomerInvoiceList}
        page={page}
        rowsPerPage={rowsPerPage}
        isLotList={false}
      />

    </Container>
  )
}